import React, { useEffect, useRef, useState } from "react";

// Img
// import bannerImg from "../../../assets/png/banner-image.png";

import {
  ActionButton,
  Button,
  Container,
  Icon,
  Image,
  InputField,
  Notifications,
} from "@jds/core";

// Local
import useInput from "../../../hooks/use-input";
import useApiHttp from "../../../hooks/use-http";
import { validateTextInput } from "../../../util/validation";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

export default function NameOfFaceForm(props) {
  const { closeModal, close, eventDetails, data } = props;
  const { id: eventId } = useParams();

  const { sendRequest: nameUpdate, isLoading: nametUpdateing } = useApiHttp();

  const {
    value: name,
    isValid: nameIsValid,
    hasError: nameHasError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
    reset: resetnameInput,
  } = useInput(validateTextInput, {
    type: "text",
    value: props?.staticName || data?.username,
  });

  const formSubmitHandler = async (e) => {
    nameBlurHandler(name);
    if (nameIsValid) {
      closeModal();
      nameUpdate(
        {
          url: `face/cluster/tag-name?clusterId=${data?.clusterId}&tagName=${name}&eventId=${eventId}`,
          method: "POST",
          base: "MEDIA",
          body: {
            eventId,
            tagName: name,
            clusterId: data?.clusterId,
          },
        },
        null,
        (res) => {
          closeModal();
          Notifications.toast.success({ id: "tag-name", title: res.message });
          props?.isSuccess(true, name, data?.clusterId);
        },
        (err, data) => {
          Notifications.toast.error({ id: "tag-name", title: data.message });
        }
      );
    }
  };

  return (
    <div>
      <Container
        fullWidth
        horizontalAlign="center"
      // style={{ width: "calc(100% + 64px)", marginLeft: "-32px" }}
      >
        {/* <Image
          src={data?.mediaUrl || ""}
          alt="face"
          aspectRatio="16:9"
          roundedCorner={false}
        /> */}
        <Box width={120}>
          <Image src={data?.mediaUrl || ""} alt="face" aspectRatio="round" />
        </Box>
      </Container>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formSubmitHandler();
        }}
      >
        <InputField
          label="Add Name"
          value={name}
          onChange={nameChangeHandler}
          state={nameHasError ? "error" : "none"}
          stateConfig={{ errorText: "Please enter a valid name!" }}
          suffix={<Icon ic={name ? "IcSuccessColored" : "IcEditPen"} />}
          autoFocus={true}
        />
        <Container
          fullWidth
          horizontalAlign="center"
          style={{ marginTop: "16px" }}
        >
          <Button
            type="submit"
            disabled={nametUpdateing}
            kind={nametUpdateing ? "loading" : "default"}
            size="large"
            label="Save"
          />
        </Container>
      </form>
    </div>
  );
}
